var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7511 24.9505L19.6772 20.5884L19.6089 0.814571C19.6073 0.352963 20.0892 0.0487935 20.5052 0.248829L29.1076 4.38548C29.3242 4.48962 29.462 4.70874 29.462 4.94905V24.5035C29.4619 24.8689 29.0803 25.1088 28.7511 24.9505Z",
    fill: "#2166CD",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.677 20.5883L9.85645 15.8665L19.3108 0.300791C19.4778 0.0258181 19.8263 -0.0775684 20.1163 0.0618273L28.8389 4.25635C29.1723 4.41671 29.2944 4.82988 29.1017 5.14565L19.677 20.5883Z",
    fill: "#2166CD",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6769 20.5883L9.85632 15.8665L0.854816 1.2084C0.604023 0.800022 1.0404 0.316479 1.47229 0.52415L9.85632 4.55577L19.6769 20.5883Z",
    fill: "#2166CD",
    fillOpacity: 0.73
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14561 24.9503L0.281037 20.6876C0.109226 20.605 0 20.4312 0 20.2406V0.580043C0 0.226238 0.369601 -0.00621253 0.688519 0.147183L9.85652 4.55581V24.5033C9.85652 24.8687 9.47486 25.1087 9.14561 24.9503Z",
    fill: "#2166CD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.8ea77a2efdd8cfbb7685360cba429b1c.svg";
export { ForwardRef as ReactComponent };